import styled from 'styled-components';
import { flexbox, justifyContent, flexDirection, alignItems, flex } from '../../styles/helpers/flexbox';

const TopQuestionsWrapper = styled.div(() => `
  border-top: 1px solid #cfd2d4;
  font-family: poppins, Arial, sans-serif;
  font-size: 14px;
  line-height: 18px;
  position: relative;
  border-radius: 5px 5px 0 0;
  margin-bottom: 10px;
  ${flex(1, 0)}

  .row {
    border: 1px solid #cfd2d4;
    border-top: none;
    ${flexbox()};
    ${flexDirection('row')};
    ${alignItems('flex-end')};

    padding: 3px 10px;
    height: 23px; // fixed becuase sizes of domain icons are different, 23 = max height

    .number {
      width: 30%;
      text-align: left;
    }

    .view {
      width: 20%;
      text-align: center;
      text-decoration: underline;
      cursor: pointer;
    }

    .percentage {
      width: 20%;
      text-align: right;
      color: #900012;
    }
  }
`);

const TopQuestionsHeader = styled.div(() => `
  border-left: 1px solid #cfd2d4;
  border-right: 1px solid #cfd2d4;
  border-bottom: 0.5px solid #cfd2d4;
  border-radius: 5px 5px 0 0;
  ${flexbox()};
  ${flexDirection('row')};
  ${justifyContent('space-between')};
  padding: 5px 10px 3px;

  .header-text {
    font-weight: bold;
  }
`);

const Icon = styled.div`
    ${flexbox()};
    ${flexDirection('column')};
    ${justifyContent('flex-end')};

    pointer-events: none;
`;

const DomainWrapper = styled.div`
  width: 30%;
  height: 100%;
  position: relative;

  ${flexbox()};
  ${flexDirection('row')};
  ${justifyContent('center')};
`;

const EmptyQuestionsWrapper = styled.div`
  ${flexbox()};
  ${flexDirection('column')};
  ${justifyContent('space-between')};

  border: 1px solid #cfd2d4;
  font-family: poppins, Arial, sans-serif;
  font-size: 14px;
  line-height: 18px;
  text-align: left;
  position: relative;
  border-radius: 0;
  padding: 25px 30px;
  ${flex(1, 0)};

  p:not(:last-child) {
    margin-bottom: 10px;
  }

  strong {
    color: inherit;
  }

  .no-recommendations {
    ${flexbox()};
    ${flexDirection('row')};
    ${justifyContent('center')};

    margin: auto;
  }
`;

export {
  TopQuestionsWrapper,
  TopQuestionsHeader,
  Icon,
  DomainWrapper,
  EmptyQuestionsWrapper
};

